import PricingBreakdown, { PricingStatusBanner } from "./PricingBreakdown";

function PricingSectionAwaitingApproval({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      <div className="flex items-center justify-between mb-4 gap-2">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
        <PricingStatusBanner data={data} />
      </div>
      <p className="text-xs text-gray-500 mb-3">
        Agent accepted the quote. Confirm you have sent the refund to the
        airline.
      </p>
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        <PricingBreakdown data={data} />
      </div>
    </div>
  );
}

export default PricingSectionAwaitingApproval;
